/**
 * Aviso flotante: subida de fotos/documentos en segundo plano (no bloquea la ficha).
 */
export default function BarraSubidaFondo({ stats, onReintentar }) {
  const { pendientes, subiendo, errores, completados, mensajesError = [] } = stats;
  const activo = pendientes > 0 || subiendo > 0 || errores > 0;
  if (!activo) return null;

  const total = pendientes + subiendo + errores + completados;
  const hecho = completados + (total - pendientes - subiendo - errores);
  const pct = total > 0 ? Math.round((hecho / total) * 100) : 0;
  const detalleError = mensajesError.find((m) => String(m || "").trim()) || null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: 72,
        left: 16,
        zIndex: 50,
        maxWidth: 360,
        background: "rgba(15, 23, 42, 0.94)",
        color: "#f8fafc",
        borderRadius: 12,
        padding: "12px 16px",
        boxShadow: "0 8px 32px rgba(0,0,0,0.35)",
        fontSize: 13,
        lineHeight: 1.45,
      }}
    >
      {subiendo > 0 || pendientes > 0 ? (
        <>
          <div style={{ fontWeight: 700, marginBottom: 6 }}>
            Subiendo archivos en segundo plano…
          </div>
          <div style={{ opacity: 0.9, marginBottom: 8 }}>
            Puedes seguir rellenando la ficha.
            {completados > 0 || total > 0 ? ` ${completados}/${total} guardados` : ""}
            {subiendo > 0 ? ` · ${subiendo} en curso` : ""}
            {pendientes > 0 ? ` · ${pendientes} en cola` : ""}
          </div>
          <div
            style={{
              height: 6,
              borderRadius: 999,
              background: "rgba(255,255,255,0.15)",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                height: "100%",
                width: `${Math.max(pct, subiendo > 0 ? 8 : 0)}%`,
                background: "linear-gradient(90deg, #38bdf8, #2563eb)",
                transition: "width 0.4s ease",
              }}
            />
          </div>
        </>
      ) : null}

      {errores > 0 && (
        <div style={{ marginTop: subiendo > 0 || pendientes > 0 ? 10 : 0 }}>
          <div style={{ fontWeight: 700, color: "#fca5a5", marginBottom: 4 }}>
            {errores} archivo{errores !== 1 ? "s" : ""} no se {errores !== 1 ? "subieron" : "subió"}
          </div>
          <div style={{ opacity: 0.85, marginBottom: 8, whiteSpace: "pre-wrap" }}>
            {detalleError
              || "Los datos de la ficha están guardados. Pulsa reintentar; no hace falta volver a seleccionar los archivos."}
          </div>
          {typeof onReintentar === "function" && (
            <button
              type="button"
              onClick={onReintentar}
              style={{
                padding: "6px 14px",
                borderRadius: 8,
                border: "1px solid #fca5a5",
                background: "transparent",
                color: "#fecaca",
                fontWeight: 700,
                cursor: "pointer",
                fontSize: 12,
              }}
            >
              Reintentar subida
            </button>
          )}
        </div>
      )}
    </div>
  );
}
